import { LeadFormFields } from 'types/LeadForm';
import { getMostRecentLeadSubmission } from 'lib/mostRecentLeadSubmission';

import useSession from './useSession';
import { useAutolistUser } from './useAutolistUser';

interface useLeadFormInitialDataParams {
  fromAccount?: boolean;
}

export function useLeadFormInitialData(params?: useLeadFormInitialDataParams): LeadFormFields {
  const { isSignedIn } = useSession();
  const autolistUser = useAutolistUser();

  const mostRecentLeadSubmission = getMostRecentLeadSubmission();
  if (!params?.fromAccount && mostRecentLeadSubmission) {
    return {
      name: mostRecentLeadSubmission.name,
      email: mostRecentLeadSubmission.email,
      phone: mostRecentLeadSubmission.phone,
      message: '',
    };
  }

  if (isSignedIn) {
    return {
      name: `${autolistUser.firstName || ''} ${autolistUser.lastName || ''}`.trim(),
      email: autolistUser.email || '',
      phone: autolistUser.phone || '',
      message: '',
      zip: autolistUser.zip || '',
    };
  }

  return {
    email: '',
    name: '',
    phone: '',
    message: '',
  };
}
